import React from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './header.css'

const Header = (props) => {
  return (
    <section className={`header-container Fade_in_up1 ${props.rootClassName} `}>
      <div className="header-nav">
        <Link to="/" className="header-navlink Cursor">
          {props.Home}
        </Link>
        <Link to="/work" className="header-navlink1 Cursor">
          {props.Work}
        </Link>
        <Link to="/about" className="header-navlink2 Cursor">
          {props.About}
        </Link>
      </div>
    </section>
  )
}

Header.defaultProps = {
  rootClassName: '',
  Home: 'Home',
  Work: 'Artwork',
  About: 'About Me',
}

Header.propTypes = {
  rootClassName: PropTypes.string,
  Home: PropTypes.string,
  Work: PropTypes.string,
  About: PropTypes.string,
}

export default Header
